export default function getVisitTypeFromFilename(filename: string) {
  // Define a regex pattern to extract the visit type
  //This pattern works well in place of just grabbing the visit type names from the db, but for
  //now we will stick to grabbing the names instead
  const pattern = /_(?!ProgressNote)([A-Za-z- ]+)_/

  const visitTypes = [
    'Case review',
    'CHN Care Management',
    'CHN Telehealth Care  Management',
    'Comprehensive Follow-up',
    'Comprehensive Initial (ext)',
    'Medical - Care Coordination',
    'Medical - Comprehensive Annual',
    'Medical - Comprehensive Initial',
    'Medical - Drop in',
    'Medical - Family Meeting',
    'Medical - Follow up',
    'Medical - Hospital',
    'Medical - Medic',
    'Medical - Previsit',
    'Medical - Referral Care Coordination',
    'Medical - Referral Comprehensive Initial',
    'Medical - Ride along',
    'Medical - SNF/LTC',
    'Medical - Thrive Initial',
    'Medical - Transition Coordination',
    'Medical - Transition of Care',
    'Medical - Tuck in',
    'Medical - Urgent',
    'Medical - Welcome',
    'Medical Telehealth - Comprehensive Annual',
    'Medical Telehealth - Comprehensive Initial',
    'Medical Telehealth - Family Meeting',
    'Medical Telehealth - Follow up',
    'Medical Telehealth - SNF/LTC',
    'Medical Telehealth - Transition of Care',
    'Medical Telehealth - Tuck in',
    'Medical Telehealth - Urgent',
    'MoreCare-Intro',
    'On Call Encounter',
    'Other',
    'Paramedic Encounter',
    'PCT Drop In',
    'PCT Follow UP',
    'PCT Initial',
    'PCT TuckIn',
    'Pharmacy - Telehealth',
    'Post Hospital Care',
    'PSV (CA) - Comp. Initial (ext)',
    'PSV (CA) - Comprehensive Annual',
    'PSV (CA) - Comprehensive Initial',
    'PSV (CA) - Family Meeting',
    'PSV (CA) - Follow up',
    'PSV (CA) - Transition Of Care',
    'PSV (CA) - Urgent',
    'PSV (P) - Comp. Initial (ext)',
    'PSV (P) - Comprehensive Annual',
    'PSV (P) - Comprehensive Initial',
    'PSV (P) - Family Meeting',
    'PSV (P) - Follow up',
    'PSV (P) - Transition Of Care',
    'PSV (P) - Urgent',
    'Social Work - Complex Care Management',
    'Social Work - Comprehensive Initial',
    'Social Work - Drop in',
    'Social Work - Family Meeting',
    'Social Work - Follow up',
    'Social Work - Hospital',
    'Social Work - Initial',
    'Social Work - Ride along',
    'Social Work - SNF/LTC',
    'Social Work - Tuck in',
    'Social Work - Urgent',
    'SW - Follow up',
    'SW Telehealth - Complex Care Management',
    'SW Telehealth - Comprehensive Initial',
    'SW Telehealth - Family Meeting',
    'SW Telehealth - Follow up',
    'SW Telehealth - SNF/LTC',
    'SW Telehealth - Tuck in',
    'SW Telehealth - Urgent',
  ]

  let foundType = '-'
  if (visitTypes != undefined) {
    for (let i = 0; i < visitTypes.length; i++) {
      const currentType = visitTypes[i]
      if (filename.toLowerCase().includes(currentType.toLowerCase())) {
        foundType = currentType
      }
    }
  }

  return foundType
}
